import { Box } from '@mui/material';
import type React from 'react';

import useScreenSize from '../../../utils/useScreenSize';

// The illustrations are 1200×1800. Sizing the box from the ratio keeps the layout stable
// before the JPEG has loaded: Chrome lays out a still-loading <img> as 0×0 otherwise.
const IMAGE_ASPECT_RATIO = '2 / 3';

interface OnboardingStepImageProps {
	src: string;
}

const OnboardingStepImage: React.FC<OnboardingStepImageProps> = ({ src }) => {
	const { isLgScreen } = useScreenSize();

	if (!isLgScreen) return null;

	return (
		<Box
			component="img"
			src={src}
			alt=""
			aria-hidden
			data-testid="onboarding-page-image"
			sx={{ display: 'block', width: `calc(100vh * ${IMAGE_ASPECT_RATIO})`, height: '100vh' }}
		/>
	);
};

export default OnboardingStepImage;
